import Vue from "vue";
import Vuetify from "vuetify/lib";
import { pt } from "vuetify/lib/locale";
import { en } from "vuetify/lib/locale";

Vue.use(Vuetify);

const ptBr = {
  ...pt,
  input: {
    ...(pt as any).input,
    appendAction: "ação adicional",
  },
  noDataText: "Nenhum dado disponível",
  dataFooter: {
    ...(pt as any).dataFooter,
    prevPage: "Página anterior",
    nextPage: "Próxima página",
  },
  dataTable: {
    ...(pt as any).dataTable,
    ariaLabel: {
      ...((pt as any).dataTable && (pt as any).dataTable.ariaLabel),
      sortNone: "Não ordenado",
      activateAscending: "Ativar ordenação crescente",
    },
  },
};

export default new Vuetify({
  lang: {
    locales: {
      pt: ptBr,
      en,
    },
    current: "pt",
  },
  icons: {
    iconfont: "mdi",
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#A04DC2",
        secondary: "#F0ECF4",
        dark: "#111816",
        gray: "#F6F7F5",
        lightGray: "#ECEFEB",
        offWhite: "#F9FAF8",
        black: "#101828",
        mediumBlack: "#1E2723",
        mediumGray: "#69736D",
        darkGray: "#9CA6A0",
        important: "#FB3A04",
        lightImportant: "#FEF2F2",
        white: "#FFFFFF",
        accent: "#7E3AA2",
        error: "#D35D5D",
      },
    },
  },
});
